import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        height: '650px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        border: '1px solid #e0e0e0',
        '&.MuiCard-root': {
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        }
    },
    scrollableContent: {
        flex: 1,
        // overflowY: 'auto',
        // overflowX: 'hidden',
        padding: '20px',
        // paddingBottom: '60px',
        boxSizing: 'border-box',
        minHeight: '200px',
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none', // IE and Edge
        '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Opera
        },
    },
    noBlocksContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '20px',
    },
    sectionTitleText: {
        fontWeight: 400,
        fontSize: 14,
        color: '#78798E',
        fontStyle: 'normal',
        lineHeight: '21px',
        [theme.breakpoints.down('md')]: { fontSize: 13.5, lineHeight: '20px' },
        [theme.breakpoints.down('sm')]: { fontSize: 13, lineHeight: '19px' },
    },
    sectionTitleTextClamp: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: 300,
        [theme.breakpoints.down('lg')]: { maxWidth: 260 },
        [theme.breakpoints.down('md')]: { maxWidth: 220 },
        [theme.breakpoints.down('sm')]: { maxWidth: 180 },
        [theme.breakpoints.down('xs')]: { maxWidth: 150 },
    },
}));

export default useStyles;
